// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1JHXl","header":"ClearentDisclaimer_header__1uTRc","inner":"ClearentDisclaimer_inner__h1rR0"};